export default "__VITE_ASSET__5omatCta__"